import React from 'react';
import { bool, object } from 'prop-types';
import UserPropType from '../../../../proptypes/UserPropType';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { MapStatsUtil } from '../../../../utils/map_stats_util';

import SplitSection from '../SplitSection';

import * as styles from './styles/styles.module.scss';

const SplitsTab = ({ splits, displayMetric, currentUser }) => {
  const displaySpeed = currentUser && currentUser.displaySpeed;
  const paceSpeedTitle = displaySpeed ? StringConstantsMixin.strings.STATS.NORMAL.AVG_SPEED : StringConstantsMixin.strings.STATS.NORMAL.PACE;
  const splitsData = displayMetric ? splits.metric : splits.imperial;

  return (
    <div className={styles.splitsContainer}>
      <div className={styles.splitLabels}>
        <span className={styles.splitLabel}>
          {displayMetric ? StringConstantsMixin.strings.STATS.NORMAL.KILOMETERS : StringConstantsMixin.strings.STATS.NORMAL.MILES}
        </span>
        <span className={styles.splitLabel}>{paceSpeedTitle}</span>
        <span className={styles.splitLabel}> {StringConstantsMixin.strings.STATS.NORMAL.ELEV_GAIN} </span>
      </div>
      {splitsData.map((split, i) => {
        return (
          <div className={styles.splits} key={i}>
            <SplitSection data={split.distance.toFixed(1)} />
            <SplitSection
              data={`${displaySpeed ? split.avg_speed.toFixed(2).toString() : MapStatsUtil.secondsToTimeNo24HourLimit(split.pace)}`}
              pace
              splitBar={split.bar}
            />
            <SplitSection data={MapStatsUtil.formatData(split.elevation, 0, displayMetric ? ' m' : ' ft')} />
          </div>
        );
      })}
    </div>
  );
};

SplitsTab.propTypes = {
  splits: object,
  displayMetric: bool,
  currentUser: UserPropType
};

SplitsTab.defaultProps = {
  splits: {},
  displayMetric: false,
  currentUser: {}
};

export default SplitsTab;
